export default __webpack_public_path__ + "logo.png?5b900b2ae38089c6ad1f1bead058e2c0";